var map = {
	"./base.jpg": 4591,
	"./futuristic.jpg": 6148,
	"./luxury.jpg": 2415,
	"./metropolitan.jpg": 9870,
	"./skyline.jpg": 4731,
	"./vibrance.jpg": 662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3047;